import * as React from 'react';
const FedexIcon = props => {
  const fill = props.color ? props.color : '#fff';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="spedizionieri_icon"
      data-name="spedizionieri icon"
      viewBox="0 0 681.65 209.3"
      {...props}
    >
      <defs>
        <style>{`.cls-1{fill:${fill};fill-rule:evenodd}`}</style>
      </defs>
      <path
        d="m621.38 201.41-27.88-31.32-27.67 31.32H507.7l56.84-63.92-56.84-63.92h60.06l28.1 31.1 27.24-31.1h57.91l-56.63 63.7 57.27 64.14h-60.27z"
        className="cls-1"
      />
      <path
        d="M395.74 201.41V0H507.7v44.83h-64.56v28.74h64.56v43.11h-64.56v39.68h64.56v45.05H395.74z"
        className="cls-1"
      />
      <path
        d="M348.55 0v82.36h-.43c-10.51-12.01-23.59-16.09-38.61-16.09-31.1 0-54.27 21.02-62.63 48.9-9.44-30.67-33.46-49.55-69.28-49.55-28.96 0-51.91 13.08-63.92 34.32V73.56H53.62V44.82h65.42V0H0v201.41h53.62V116.9h53.41c-1.72 6.43-2.57 13.3-2.36 19.95 0 42.04 32.17 71.43 73.14 71.43 34.53 0 57.27-16.3 69.28-45.69h-45.9c-6.22 8.79-10.94 11.58-23.38 11.58-14.8-.43-26.81-12.65-26.81-27.45h93.3c4.08 33.46 30.03 62.2 65.85 62.2 15.23 0 29.6-7.72 38.18-20.38h.43v12.87h47.19V0h-47.4ZM152.29 117.33c3-12.87 12.87-21.23 25.31-21.23 13.73 0 23.17 8.15 25.52 21.23h-50.83Zm167.73 53.41c-17.37 0-28.1-16.3-28.1-33.03 0-18.02 9.44-35.39 28.1-35.39s27.24 17.37 27.24 35.39-8.37 33.03-27.24 33.03Z"
        className="cls-1"
      />
    </svg>
  );
};
export default FedexIcon;
